import React, { Component } from "react";
import { Progress } from "reactstrap";
import _axios from "../../libs/axios";
import { openLink } from "../../helpers/Utils"
import { NotificationManager } from "../common/react-notifications";
import { cloneDeep } from "lodash"

export default class CustomDropzone extends Component {
  constructor(props) {
    // console.log(props)
    super(props);
    let s = {}
    s[props.name] = props.value
    s.files = []
    s.drag = false
    s.progressPercentage = 0
    s.progressBytes = 0
    s.cancel = null
    s.cancelToken = null
    s.upload = null
    s.maxFiles = (this.props.opts && this.props.opts.maxFiles) ? this.props.opts.maxFiles : 1
    s.urlFile = props.opts.url
    s.accept = ".gif, .jpg, .jpeg, .png, .pdf, .docx, .xlsx, .zip"
		this.state = s
	}

  componentDidUpdate (prevProps, prevState) {
    if (this.props.uploadFiles && this.props.name === this.props.uploadFiles.name && this.state.upload === null && prevState.upload === null) {
      this.setState({upload: cloneDeep(this.props.uploadFiles)}, () => {
        this.state.files.length === 0 ? this.state.upload.success() : this.save(0)
      })
    }
    if (this.props.uploadFiles !== prevProps.uploadFiles && !prevProps.uploadFiles && this.state.upload) this.setState({upload: null})
  }

  isImage = (extensions) => {
    if (!extensions) return false
    extensions = extensions.toLowerCase()
    var imageFormats = [".jpeg", ".jpg", ".png", ".gif"];
    for (var i = 0; i < imageFormats.length; i++) {
      if (extensions.includes(imageFormats[i])) return true
    }
    return false
  }

  isDoc = (ext) => {
    if (!ext) return false
    return ['gif','jpg','png','jpeg'].indexOf(ext) === -1
  }

  save (i, data) {
    if (i > (this.state.files.length - 1)) {
      this.state.upload.success(data)
      return
    }
    
    const body = {
      name: this.props.name + '.' + this.state.files[i].ext,
      doc: this.isDoc(this.state.files[i].ext),
      data: this.state.files[i].value
    }

    const CancelToken = _axios.CancelToken;
    let ctx = this;
    _axios.post(this.props.opts.path()+'?id=' + this.state.upload.id, body,
    {
      onUploadProgress: (progressEvent) => {
        var p = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        this.setState({progressPercentage: p, progressBytes: progressEvent.loaded});
      },
      cancelToken: new CancelToken(function executor(c) {
        ctx.setState({cancel: c})
      })
    })
    .then(r => {
      if (r.status >= 0) {
        this.save(i + 1, r.data)
      } else {
        NotificationManager.error(r.msg || '', "Error", 5000, null, null, 'outline')
        this.props.uploadFiles.error(r)
        this.clear()
      }
    })
    .catch((e) => {
      this.props.uploadFiles.error(e)
      this.clear()
    })
  }

  clear () {
    this.setState({
      progressPercentage: 0,
      progressBytes: 0,
      cancel: null,
      cancelToken: null,
      upload: null
    })
  }

  handleOnDrop = (e) => {
    e.preventDefault()
    this.setState({drag: false})
    let files = []
    if (e.dataTransfer.items) {
      for (var i = 0; i < e.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (e.dataTransfer.items[i].kind === 'file') {
          files.push(e.dataTransfer.items[i].getAsFile())
        }
      }
      if (files.length > 0) this.validateFile(files)
    } else {

    }
    this.removeDragData(e)
  }

  handleOnDragOver = (e) => {
    this.setState({drag: true})
    e.preventDefault();
  }

  handleOnChange = (e) => {
    // console.log(e.target.files)
    const files = e.target.files
    if (!files || files.length === 0) return
    this.validateFile(files)
  }

  removeDragData(e) {
    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to remove the drag data
      e.dataTransfer.items.clear()
    } else {
      // Use DataTransfer interface to remove the drag data
      e.dataTransfer.clearData()
    }
    this.setState({drag: false})
  }

  getBase64 = (f) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  validateFile(files) {
    let length = files.length + this.state.files.length
    if (length > this.state.maxFiles) {
      NotificationManager.error('Solo se admite como máximo ' + this.state.maxFiles + ' archivos', 'Error', 5000, null, null, 'outline')
      return
    }
    this.addFile(files)
  }

  addFile = (files) => {
    // console.log(files)
    let n = []
    let convert = (i) => {
      if (i > (files.length - 1)) {
        const newsFiles = this.state.files.concat(n)
        this.setState({files: newsFiles}, () => { /*console.log(this.state.files) */ })
        if (this.props.opts.output) this.props.onChange(newsFiles)
        return
      }
      this.getBase64(files[i]).then(
        data => {
          n.push({name: files[i].name, size: files[i].size, type: files[i].type, value: data, ext: files[i].name.split('.').pop() })
          i = i + 1
          convert(i)
        }
      );
    }
    convert(0)
  }

  deleteFile = (i) => {
    const temp = this.state.files
    temp.splice(i,1)
    this.setState({files : temp})
    if (temp.length === 0) this.props.onChange(null)
  }

  render() {
    const { name, disabled, icon } = this.props
    const placeholderIcon = icon || (this.isImage(this.props.opts.accept) ? "simple-icon-camera" : "simple-icon-doc")
    return (
      <div className="cs-dropzone">
        <div className="cs-content">
          {this.state.files.length > 0 && <div>
            {this.state.files.length === 1 && ['gif','jpg','jpeg','png'].includes(this.state.files[0].ext)
              ? <div className="cs-one-file">
                  {!disabled &&
                    <div className="cs-ic-delete" onClick={this.state.progressPercentage > 0 ? ()=> {this.state.cancel()} : ()=> {this.deleteFile(this.state.files[0])}}>
                      <i className="simple-icon-trash"></i>
                    </div>
                  }
                  <div className="cs-detail">
                    <div className="cs-detail-content-img">
                      <img 
                        alt=""
                        src={this.state.files[0].value}
                      />
                      {this.state.progressPercentage > 0 && 
                        <div className="cs-wrap-progressbar">
                          <div className="cs-progressbar"><Progress value={this.state.progressPercentage}/></div>
                          <div className="cs-progressnum"><div>{this.state.progressPercentage}%</div></div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              : <div className="cs-list">
                  {this.state.files.map((f, i) => {
                    return <div className="cs-item" key={i}>
                      <div className="cs-row">
                        {/* <div className="cs-type">{f.type}</div> */}
                        <div className="cs-name">{f.name}</div>
                        {!disabled &&
                          <div className="cs-ic" onClick={this.state.progressPercentage > 0 ? ()=> {this.state.cancel()} : ()=> {this.deleteFile(i)}}>
                            <i className="simple-icon-trash"></i>
                          </div>
                        }
                      </div>
                      {this.state.progressPercentage > 0 && 
                        <div className="cs-row">
                          <div className="cs-progressbar"><Progress value={this.state.progressPercentage}/></div>
                          <div className="cs-progressnum"><div>{this.state.progressPercentage}%</div></div>
                        </div>
                      }
                    </div>
                  })}
                </div>
            }
          </div>
          }

          {this.state[name] && typeof this.state[name] === 'string' && <div className="cs-one-file">
            {!disabled &&
              <div className="cs-ic-delete" onClick={() => { this.setState({[name] : null}); this.props.onChange(null) }}>
                <i className="simple-icon-trash"></i>
              </div>
            }
            <div className="cs-detail">
              {['.gif', '.jpg', '.jpge', '.png', ].some(ext => this.state.urlFile?.includes(ext))
                ? <div className="cs-detail-content-img" onClick={() => { openLink(this.state.urlFile) }}>
                    <img 
                      alt="" 
                      src={this.state.urlFile} 
                      onError={(e) => { e.target.onerror = null; e.target.src = require("../../assets/img/user.png") }} 
                    />
                  </div>
                : <div className="cs-detail-content" onClick={() => { openLink(this.state.urlFile) }}>
                    <div className="cs-name btn-link">{this.state[name]}</div>
                    <div className="cs-ic-download">
                      <i className="simple-icon-cloud-download"></i>
                    </div>
                  </div>
              }
            </div>
          </div>
          }
          
          {this.state[name] && Array.isArray(this.state[name]) && <div className="cs-list">
            <div className="cs-item">
              <div className="cs-row">
                <div className="cs-name btn p-0 btn-link" onClick={() => { openLink(this.state.urlFile) }}>{this.state[name]}</div>
                <div className="cs-ic mr-1" onClick={() => { openLink(this.state.urlFile) }}>
                  <i className="simple-icon-cloud-download"></i>
                </div>
                {!disabled &&
                  <div className="cs-ic" onClick={() => {}}>
                    <i className="simple-icon-trash"></i>
                  </div>
                }
              </div>
            </div>
          </div>
          }

          {((this.state.files.length < this.state.maxFiles) && !this.state[name]) && <div className={"cs-zone" + (this.state.files.length === 0 ? '' : ' reduce') + (this.state.drag ? ' active' : '')} onDrop={this.handleOnDrop} onDragOver={this.handleOnDragOver}>
            <div className="cs-placeholder">
              <i className={placeholderIcon}></i>
              {this.props.placeholder && <p>{this.props.placeholder.replace('{0}', this.props.opts?.accept?? this.accept)}</p>}
            </div>
            <input type="file" onChange={this.handleOnChange}  multiple={!!this.props.opts?.multiple} accept={this.props.opts?.accept?? this.accept}/>
          </div>
          }
        </div>
      </div>
    );
  }
}
